import { render } from "./createContract.vue?vue&type=template&id=0774d375&scoped=true"
import script from "./createContract.vue?vue&type=script&lang=js"
export * from "./createContract.vue?vue&type=script&lang=js"

import "./createContract.vue?vue&type=style&index=0&id=0774d375&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0774d375"]])

export default __exports__